/**
 * M List left sidebar: Values, Authority, Philanthropy, Categories (expandable), CTA.
 */
import React from "react";
import { Link } from "react-router-dom";
import MListSidebarFilterGroup from "./MListSidebarFilterGroup";
import MListSidebarCategoryGroup from "./MListSidebarCategoryGroup";
import { VALUE_FILTERS, BADGE_FILTERS, PHILANTHROPY_FILTERS } from "./mlistFilterConfig";

export default function MListSidebar({
  groupings,
  selectedTagIds,
  onTagIdsChange,
  onClearCategoryFilters,
  hasCategorySelection,
  valueIds,
  onValueIdsChange,
  badgeIds,
  onBadgeIdsChange,
  philanthropyIds,
  onPhilanthropyIdsChange,
  onClearAll,
  hasActiveFilters,
}) {
  const categories = groupings ?? [];

  return (
    <aside className="twentytwentysix-content__mlist-sidebar" aria-label="Filter listings">
      {hasActiveFilters && (
        <button
          type="button"
          className="twentytwentysix-content__filter-pill twentytwentysix-content__mlist-sidebar-clear"
          onClick={onClearAll}
        >
          Clear all filters
        </button>
      )}

      <MListSidebarFilterGroup
        title="Values"
        options={VALUE_FILTERS}
        selectedIds={valueIds}
        onChange={onValueIdsChange}
        ariaLabel="Value-based filters"
      />

      <MListSidebarFilterGroup
        title="Authority"
        options={BADGE_FILTERS}
        selectedIds={badgeIds}
        onChange={onBadgeIdsChange}
        ariaLabel="Authority and badge filters"
      />

      <MListSidebarFilterGroup
        title="Philanthropy"
        options={PHILANTHROPY_FILTERS}
        selectedIds={philanthropyIds}
        onChange={onPhilanthropyIdsChange}
        ariaLabel="Philanthropy filters"
      />

      <p className="twentytwentysix-content__mlist-sidebar-title">Categories</p>
      {hasCategorySelection && (
        <button
          type="button"
          className="twentytwentysix-content__filter-pill twentytwentysix-content__mlist-sidebar-clear-categories"
          onClick={onClearCategoryFilters}
        >
          Clear categories
        </button>
      )}
      <div className="twentytwentysix-content__mlist-sidebar-groups">
        {categories.map((g) => (
          <MListSidebarCategoryGroup
            key={g.id ?? g.name}
            grouping={g}
            selectedTagIds={selectedTagIds}
            onTagIdsChange={onTagIdsChange}
          />
        ))}
      </div>

      <div className="twentytwentysix-content__mlist-sidebar-cta">
        <p className="twentytwentysix-content__copy">Are you a business? Get M-Listed!</p>
        <Link to="/twentytwentysix/contact" className="twentytwentysix-content__pill twentytwentysix-content__pill--outline">
          Contact us
        </Link>
      </div>
    </aside>
  );
}
